/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SiloLens, SiloLensInterface } from "../SiloLens";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISiloRepository",
        name: "_siloRepo",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "DifferentArrayLength",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsupportedLTVType",
    type: "error",
  },
  {
    inputs: [],
    name: "UserIsZero",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAssets",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_assetTotalDeposits",
        type: "uint256",
      },
      {
        internalType: "contract IShareToken",
        name: "_shareToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "balanceOfUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "borrowAPY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "borrowShare",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "calcFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "calculateBorrowValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "calculateCollateralValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "collateralBalanceOfUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "collateralOnlyDeposits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "debtBalanceOfUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "depositAPY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "getBorrowAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "getDepositAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "totalUserDeposits",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getModel",
    outputs: [
      {
        internalType: "contract IInterestRateModel",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "getUserLTV",
    outputs: [
      {
        internalType: "uint256",
        name: "userLTV",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "getUserLiquidationThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "liquidationThreshold",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "getUserMaximumLTV",
    outputs: [
      {
        internalType: "uint256",
        name: "maximumLTV",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getUtilization",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "hasPosition",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "inDebt",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "isSolvent",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lensPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "liquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "protocolFees",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepository",
    outputs: [
      {
        internalType: "contract ISiloRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "totalBorrowAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "totalBorrowAmountWithInterest",
    outputs: [
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "totalBorrowShare",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "totalDeposits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "totalDepositsWithInterest",
    outputs: [
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type SiloLensConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SiloLensConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SiloLens__factory extends ContractFactory {
  constructor(...args: SiloLensConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SiloLens";
  }

  deploy(
    _siloRepo: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SiloLens> {
    return super.deploy(_siloRepo, overrides || {}) as Promise<SiloLens>;
  }
  getDeployTransaction(
    _siloRepo: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_siloRepo, overrides || {});
  }
  attach(address: string): SiloLens {
    return super.attach(address) as SiloLens;
  }
  connect(signer: Signer): SiloLens__factory {
    return super.connect(signer) as SiloLens__factory;
  }
  static readonly contractName: "SiloLens";
  public readonly contractName: "SiloLens";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SiloLensInterface {
    return new utils.Interface(_abi) as SiloLensInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SiloLens {
    return new Contract(address, _abi, signerOrProvider) as SiloLens;
  }
}
